import React, { useState, useEffect, useContext} from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import AOS from "aos";
import "aos/dist/aos.css";
import Web3 from "web3";
import Context from "../../../context/context";
import Staking from '../abi/staking.json';
import pTGC from '../abi/pTGC.json';
import { providerURL } from "../utils";
import { sendGetRequest } from '../../../Helper/helper'; 

const StatBox = ({ title = "Price", value = 0, delay = 0, duration = 0}) => {
  const { ref, inView } = useInView({ triggerOnce: true });
  const decimals = title === "Price" ? 8 : 2;
  
  return (
    <div className="col-lg-4">
      <div className="snState relative value mt-3" data-aos="fade-up" data-aos-delay={delay} data-aos-duration={duration} ref={ref} >
        <div className="d-flex justify-content-between">
          <div className="perVal fInter d-flex align-items-center">
            <span>{title}</span>
          </div>
        </div>
        <div>
          <h3 className="dollorValue value">
            {
              title !=="Holders" && title !=="Stakers" ?
              <>
                <span className="dollor">$</span>
              </>
              :
              <>
              </> 
            }
            {inView && <CountUp end={value} duration={2} separator="," decimals={decimals}/>}
          </h3>
        </div>
      </div>
    </div>
  );
};

const StateSection = () => {
  const {ptgcPrice} = useContext(Context);
  const [holders, setHolders] = useState(0);
  const [stakers, setStakers] = useState(0);
  const [marketCap, setMarketCap] = useState(0);
  const [burnValue, setBurnValue] = useState(0);
  const [stakedValue, setStakedValue] = useState(0);
  const [lockedValue, setLockedValue] = useState(0);
  const [liqudityValue, setLiqudityValue] = useState(0);
  const [holdValue, setHoldValue] = useState(0);

  useEffect(() => {
    AOS.init({
      once: true
    });
    getData();
  }, [ptgcPrice]);

  const stats = [
    { title: "Price", value: ptgcPrice, delay: 200},
    { title: "Market Cap", value: marketCap, delay: 400},
    { title: "Holders", value: holders, delay: 600},
    { title: "Stakers", value: stakers, delay: 800},
    { title: "Burned Value", value: burnValue, delay: 1000},
    { title: "Liqudity Value", value: liqudityValue, delay: 1200},
    { title: "Hold Value", value: holdValue, delay: 1400},
    { title: "Staked Value", value: stakedValue, delay: 1600},
    { title: "Staked & Locked Value", value: lockedValue, delay: 1800},
  ];

  const getData = async () => {
    const web3 = new Web3(providerURL());

    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    const pTGCContract = new web3.eth.Contract(pTGC.ABI, pTGC.Contract);

    const totalSupply = parseFloat(parseInt(await pTGCContract.methods.totalSupply().call()) / 10 ** 18).toFixed(2);
    const burnSupply = parseFloat(parseInt(await pTGCContract.methods.balanceOf("0x0000000000000000000000000000000000000369").call()) / 10 ** 18).toFixed(2);
    const stakedSupply = parseFloat(parseInt(await stakingContract.methods.totalStaked().call()) / 10 ** 18).toFixed(2);
    const lockedSupply = parseFloat(parseInt(await stakingContract.methods.totalLocked().call()) / 10 ** 18).toFixed(2);
    const liquiditySupply = await getLiquidityData();


    setHolders(parseInt(await pTGCContract.methods.holders().call()));
    setStakers(parseInt(await stakingContract.methods.totalStaker().call()));
    setMarketCap(ptgcPrice * (totalSupply - burnSupply));
    setBurnValue(ptgcPrice * burnSupply);
    setStakedValue(ptgcPrice * (stakedSupply - lockedSupply));
    setLockedValue(ptgcPrice * lockedSupply);
    setLiqudityValue(ptgcPrice * liquiditySupply.pTGCLiquidity);
    setHoldValue(ptgcPrice * (totalSupply - parseFloat(burnSupply + stakedSupply + liquiditySupply.pTGCLiquidity)));
  }

  const getLiquidityData = async () => {
    try {
      const response = await sendGetRequest('pairs-volumes/latest/all', 'GET');
      if (response && response.status === 200) {
        let pTGCLiquidity = 0;
        let USDLiquidity = 0;
        response.data.forEach(pair => {
          if (pair.pair.base_symbol === "pTGC") 
          {
            pTGCLiquidity += pair.base_liquidity;
            USDLiquidity += pair.liquidity;
          } 
          else if (pair.pair.qoute_symbol === "pTGC") 
          {
            pTGCLiquidity += pair.quote_liquidity;
            USDLiquidity += pair.liquidity;
          }
        });
       return { pTGCLiquidity, USDLiquidity };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  return (
    <section className="liveStats padsec PTGCSEC">
      <div className="container">
        <div className="liveStatsIn">
          <div className="d-flex align-items-center justify-content-between gap-1 flex-wrap">
            <h2>PTGC INFO</h2>
          </div>
          <div className="statsMulti">
            <div className="row">
              {stats.map((stat, idx) => (
                <StatBox
                  key={idx}
                  title={stat.title}
                  value={stat.value}
                  delay={stat.delay}
                  duration={200 + idx * 100}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StateSection;
